export default __webpack_public_path__ + "static/media/stripe-logo.19c60ef4.svg";